//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  /* global __ENV_NAME__ */
  /* global __APP_VERSION__ */
  import _ from 'lodash';
  import SidebarItemMenu from './sidebar-item-menu.vue';
  import {
    createLayout,
    createLabel,
    createList,
  } from '../item.js';
  import {bulkDelete} from '../db-utils.js';
  import {
    googleSignIn,
    googleSignOut,
    loadEvents,
  } from '../gcalendar-utils.js'
import { defaultListID } from '../reactive-cache';

  export default {
    data() {
      return {
        showCalDialog: false,
      };
    },
    components: {SidebarItemMenu},
    computed: {
      hasLabels() {
        return !!this.$settings?.labels?.length;
      },
      concealTooltip() {
        return this.$gettext(
          "Useful when you want to show Organizer to someone " +
          "without showing your actual tasks."
        )
      },
      categories() {
        return this.$settings && this.$settings.categories === true;
      },
      statuses() {
        return this.$settings && this.$settings.statuses === true;
      },
    },
    methods: {
      translatedLayoutName(name) {
        switch(name) {
          case "All lists":
            return this.$gettext("All lists");
          case "All periods":
            return this.$gettext("All periods");
          case "Items without a list":
            return this.$gettext("Items without a list");
          default:
            return name;
        }
      },
      defaultListID,
      googleSignIn,
      loadEvents,
      pruneEvents() {
        bulkDelete(
          Object.keys(this.$reactiveCache.docs)
            .filter(id => id.startsWith("gcal:"))
            .map((id) => this.$reactiveCache.docs[id])
        );
      },
      disconnectCalendar() {
        googleSignOut();
        this.pruneEvents();
      },
      toggleSetting(key, value) {
        localStorage.setItem(key, JSON.stringify(value))
      },
      goTo(route) {
        this.$router.push(route);
        this.$root.showSidebar = false;
      },
      switchLayout(layoutID) {
        this.goTo("/lists/" + layoutID);
      },
      createDashboard() {
        const name = prompt(this.$gettext('Dashboard name:'), '');
        if (name) {
          const ID = createLayout(name, this.$reactiveCache, this.$defaultDB);
          this.switchLayout(ID);
        }
      },
      createNewList(relation) {
        const name = prompt(this.$gettext('List name:'), '');
        if (name) {
          createList(name, relation, this.$reactiveCache, this.$defaultDB);
        }
      },
      async forceNetworkReload() {
        // The reload would fail if we are offline, let's not do this.
        if (!navigator.onLine) {
          throw Error('Can\'t force reload while offline.');
        }
        if (!window.confirm(this.$gettext(
                'Are all other Organizer tabs closed?\n\n' +
                'Force reload will be ineffective if there are ' +
                'more tabs/windows with open Organizer.'))) {
          return;
        }
        // First, remove all Service Workers, so that there is no rogue cache.
        const workers = await navigator.serviceWorker.getRegistrations();
        await Promise.all(workers.map((worker) => worker.unregister()));
        // After all Service Workers are removed, reload the page.
        location.reload();
      },
      saveCalendarSettings() {
        this.$root.$settings.save();
        this.showCalDialog = false;
        loadEvents();
      },
      getIcon(item) {
        if (item.icon) return item.icon;
        switch (item.type) {
          case "layout": return 'dashboard'
          case "period": return 'schedule'
          case "list": {
            switch (item.relation) {
              case "plannedFor": return "schedule"
              case "subtaskOf": return "view_list"
              case "category": return "category"
              case "status": return "assistant_direction"
            }
          }
        }
      },
      isShared(item) {
        return this.$reactiveCache.docs[item].couch.collaborators.length > 1;
      },
      isArchived(item) {
        return !!this.$reactiveCache.docs[item].archivedTimestampMs;
      },
      migrateLabels() {
        const newLabelIds = {};

        for (const label of this.$settings.labels) {
          console.log(`Migrating label "${label}"...`);
          const id = createLabel(label, this.$reactiveCache, this.$defaultDB);
          newLabelIds[label] = id;
        }

        for (const doc of Object.values(this.$reactiveCache.docs)) {
          if (doc.labels) {
            console.log(`Updating item "${doc.name}"...`);
            const newlabels = doc.labels.map(name => newLabelIds[name])
            doc.clone({labels: newlabels}).save()
          }
        }

        this.$settings.clone({labelMigrationDone: true}).save();
        setTimeout(() => {alert("Migration completed successfully.")}, 500);
      },
      updateCalendarLayout() {
        const layout = [];
        for (const id of ['days', 'weeks', 'months', 'backlog']) {
          if (this.$root.activeTimeCols.includes(id)) layout.push(id);
        }
        const layoutDoc = this.$reactiveCache.docs['calendar-view-layout']
        layoutDoc.layout = layout;
        layoutDoc.save();
      },
    },
  };
